// extracted by mini-css-extract-plugin
export default {"loginBox":"styles_loginBox__z0Cjq","imgBox":"styles_imgBox__XLRQR","formBox":"styles_formBox__8IDAt"};